import React from 'react';

function ChamadoTimeCard({
    estimativaHoras,
    tempoTrabalhadoTexto,
    tempoAnaliseTexto,
    tempoTesteTexto,
    emPeriodoAberto,
    emPeriodoAbertoAnalise,
    emPeriodoAbertoTeste,
    tempoTrabalhadoMinutos,
    usaSprint,
}) {
    const horasTrabalhadas = tempoTrabalhadoMinutos != null ? tempoTrabalhadoMinutos / 60 : 0;
    const restam = estimativaHoras != null ? Math.max(0, estimativaHoras - horasTrabalhadas) : null;

    return (
        <div className="chamado-sidebar-card chamado-time-card">
            <h4 className="chamado-sidebar-card-titulo">Tempo</h4>
            {estimativaHoras != null && (
                <div className="chamado-time-row">
                    <span className="chamado-time-label">Estimativa</span>
                    <span className="chamado-time-valor">{estimativaHoras}h</span>
                </div>
            )}
            <div className="chamado-time-row">
                <span className="chamado-time-label">{usaSprint ? 'Em desenvolvimento' : 'Em atendimento'}</span>
                <span className={`chamado-time-valor ${emPeriodoAberto ? 'chamado-time-rodando' : ''}`}>
                    {tempoTrabalhadoTexto || '00:00:00'}
                    {emPeriodoAberto && <span className="chamado-time-dot" title="Contador em andamento (rodando)" aria-label="Rodando" />}
                </span>
            </div>
            {(tempoAnaliseTexto || emPeriodoAbertoAnalise) && (
                <div className="chamado-time-row">
                    <span className="chamado-time-label">Em análise</span>
                    <span className={`chamado-time-valor ${emPeriodoAbertoAnalise ? 'chamado-time-rodando' : ''}`}>
                        {tempoAnaliseTexto || '00:00:00'}
                        {emPeriodoAbertoAnalise && <span className="chamado-time-dot" title="Contador em andamento (rodando)" aria-label="Rodando" />}
                    </span>
                </div>
            )}
            {(tempoTesteTexto || emPeriodoAbertoTeste) && (
                <div className="chamado-time-row">
                    <span className="chamado-time-label">Em teste</span>
                    <span className={`chamado-time-valor ${emPeriodoAbertoTeste ? 'chamado-time-rodando' : ''}`}>
                        {tempoTesteTexto || '00:00:00'}
                        {emPeriodoAbertoTeste && <span className="chamado-time-dot" title="Contador em andamento (rodando)" aria-label="Rodando" />}
                    </span>
                </div>
            )}
            {restam != null && restam < estimativaHoras && (
                <div className="chamado-time-row chamado-time-restam">
                    <span className="chamado-time-label">Restam</span>
                    <span className="chamado-time-valor">{restam.toFixed(1)}h</span>
                </div>
            )}
        </div>
    );
}

export default ChamadoTimeCard;
